import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line no-unused-vars
import Image from 'next/image';
// eslint-disable-next-line no-unused-vars
import noCourse from '../../../public/assets/noCourse.svg';

function PageDataNotFound({ noMsg }) {
  return (
    // <div className="flex justify-center items-center w-full p-6 bg-white rounded-lg shadow-sm">
    //   <div className="text-center flex justify-center items-center flex-col  w-full max-w-lg">
    //     <p className="text-base font-semibold text-[#334155]">
    //       {noMsg}
    //     </p>
    //     <p className="text-xs text-gray-600">
    //       Please check back later or explore content.
    //     </p>
    //   </div>
    // </div>
    <div className="flex justify-center items-center w-full lg:p-6 p-3 bg-white rounded-lg shadow-sm">
      <div className="text-red-600 text-center flex justify-center items-center flex-col">
        <Image width={140} height={160} src={noCourse} className="inline-block mb-2 w-28" alt="NoCourseFound" />
        <p className="text-sm font-normal text-[#334155]">{noMsg}</p>
      </div>
    </div>
  );
}

PageDataNotFound.propTypes = {
  noMsg: PropTypes.string,
};

export default PageDataNotFound;
